import { gql } from '@apollo/client'

import { restInvoiceClient } from './clients.configuration'

const commonReceiptFragment = `
  id
  issueDate
  customer {
    companyName
    firstName
    lastName
    title
    customerType
  }
  documentType
`

const summaryFragment = `
summary {
  foreignGrossTotal
  localGrossTotal
  exchangeRate
  localCurrency
  foreignCurrency
  localNetTotal
  localTaxTotal
}
`

const lines = `
lines {
    ... on rowLine {type,date,description,quantity,netTotal,taxTotal,grossTotal,vatPct,unit,unitPrice,totalDiscount}
  }`

export const GET_RECEIPT_QUERY = gql`
query receipt($id: Int) {
  receipt(id: $id) {
    receiptNumber
    invoiceNumber
    ${lines}
    ${commonReceiptFragment}
    ${summaryFragment}
    status {
      status
      events {
        createdAt,
        eventType
      }
    }
  }
}`

const receiptFields = `
{
  receiptNumber
  ${commonReceiptFragment}
  status {
    status
    events {
      createdAt,
      eventType
    }
  }
  ${summaryFragment}
  ${lines}
}`

const RECEIPTS_QUERY_SLIM = `
receipts {
  company {
    tradeName {
      name
    }
  }
  receiptNumber
  invoiceNumber
  ${commonReceiptFragment}
  status {
    status
  }
  ${summaryFragment}
}`

const receiptDraftFields = `
{
  ${commonReceiptFragment}
  ${summaryFragment}
  ${lines}
}`

const DRAFT_RECEIPTS_QUERY_SLIM = `
receiptDrafts {
  ${commonReceiptFragment}
  ${summaryFragment}
}`

export const GET_RECEIPTS_QUERY = gql`{
  receipts:
    receipts ${receiptFields}
}`

export const GET_ALL_RECEIPTS_QUERY = gql`{
  receipts:
    ${RECEIPTS_QUERY_SLIM}
  drafts:
    ${DRAFT_RECEIPTS_QUERY_SLIM}
}`

export const GET_RECEIPT_BY_ID_QUERY = gql`
  query receipt($id: Int) {
    receipt(id: $id) ${receiptFields}
  }`

export const GET_RECEIPT_DRAFT_BY_ID_QUERY = gql`
  query receipt($id: Int) {
    receiptDraft(id: $id) ${receiptDraftFields}
  }`

export const refreshReceipt = (id: number) => {
  return restInvoiceClient.query({
    query: GET_RECEIPT_BY_ID_QUERY,
    variables: { id },
    fetchPolicy: 'network-only',
  })
}
